import { UserSourceCreateModal } from '@app/Features/UserSource/Modals';
import type { ModalComponent, ModalKey } from './modalRegistry';

/**
 * Global modal registry.
 *
 * Architectural intent:
 * - This registry is the **single source of truth** for all modal workflows
 *   available in the application.
 * - Modals are referenced by **stable keys**, not by importing components
 *   directly at call sites.
 *
 * Why this exists:
 * - Decouples callers from modal implementations
 * - Enables a central modal stack / promise-based `open()` API
 * - Makes modal availability explicit and discoverable
 *
 * How it is used:
 * - Callers invoke `open(<ModalKey>, props)`
 * - The modal stack looks up the component here
 * - The component is rendered and given host controls (`resolve`, `close`, etc.)
 *
 * Adding a new modal:
 * 1. Create the modal component (e.g. `UserSourceCreateModal`)
 * 2. Add an entry to this registry
 * 3. Extend `ModalKey` and modal definitions accordingly
 *
 * IMPORTANT:
 * - Modal components listed here should NEVER be rendered directly.
 * - They are intended to be instantiated exclusively by the modal host.
 */
export const modalRegistry: Record<ModalKey, ModalComponent<any>> = {
  /**
   * Creates a new user source and resolves with the created result.
   */
  userSourceCreate: UserSourceCreateModal,
};
